import axios from 'axios'
import { config, url } from '../../../index'

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Название',
        isSortable: false
      }
    ]
  },
  employments: [],
  isLoading: true,
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  updateModal: {
    active: false,
    employment: {},
    validation: {}
  },
  createModal: {
    active: false,
    newEmploymentName: '',
    validation: {}
  },
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  isActiveDelete: false
})

const getters = {
  getEmploymentsList: state => state.employments,
  getEmploymentListIsLoading: state => state.isLoading,
  getEmploymentListTableHeaders: state => state.tableHeaders,
  getEmploymentListUpdateModal: state => state.updateModal,
  getEmploymentListCreateModal: state => state.createModal,
  getEmploymentListPagination: state => state.pagination,
  getEmploymentListActiveDelete: state => state.isActiveDelete,
  getEmploymentListResponseModal: state => state.responseModal
}

const mutations = {
  // получение списка всех видов занятости
  GET_EMPLOYMENTS: (state, employments) => {
    // добавляем к каждому объекту свойство для отрисовки состояния меню (ред./удалить)
    state.employments = employments.map(employment => {
      return {
        ...employment,
        isControlsActive: false,
        isActive: false
      }
    })
    // убираем флаг "контент загружается"
    state.isLoading = false
  },
  // вкл/выкл меню (редактировать/удалить)
  EMPLOYMENT_LIST_TOGGLE_CONTROLS: (state, itemId) => {
    state.employments.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  // выкл меню (редактировать/удалить) при клике вне элемента
  CLOSE_EMPLOYMENT_LIST_CONTROLS: (state) => {
    state.employments.forEach((elem) => {
      elem.isControlsActive = false
    })
  },
  // показ модалки для редактирования записи
  SHOW_EMPLOYMENT_LIST_UPDATE_MODAL: (state, employmentId) => {
    state.updateModal.active = true
    // помещаем в модалку копию объекта чтобы редактирование не затрагивало таблицу
    const copies = state.employments.map(employment => ({ ...employment }))
    state.updateModal.employment = copies.filter(employment => {
      return employment.id === employmentId
    }).shift()
  },
  SET_UPDATED_EMPLOYMENT_NAME: (state, name) => {
    state.updateModal.employment.name = name
  },
  SHOW_EMPLOYMENT_LIST_CREATE_MODAL: (state) => {
    state.createModal.active = true
  },
  SET_CREATED_EMPLOYMENT_NAME: (state, name) => {
    state.createModal.newEmploymentName = name
  },
  // закрытие всех модалок
  CLOSE_EMPLOYMENT_LIST_MODALS: (state) => {
    // модалка редактирвоания
    state.updateModal.active = false
    state.updateModal.employment = {}
    // модалка создания
    state.createModal.active = false
    state.createModal.newEmploymentName = ''
  },
  SET_EMPLOYMENT_LIST_MODAL_VALIDATION: (state, validationData) => {
    switch (validationData.modal) {
      case 'create':
        state.createModal.validation = validationData.validation
        break
      case 'update':
        state.updateModal.validation = validationData.validation
        break
      default:
        state.createModal.validation = {}
        state.updateModal.validation = {}
    }
  },
  // записть в стейт состояния пагинации
  SET_EMPLOYMENT_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_EMPLOYMENT_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },
  SET_CURRENT_PAGE: (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },
  TOGGLE_EMPLOYMENT_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.employments.length
    let counter = 0

    state.employments.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_EMPLOYMENT_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.employments.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  RESET_EMPLOYMENT_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.employments.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  // reset store
  RESET_EMPLOYMENT_LIST_STORE: (state) => {
    state.isActiveDelete = false
    state.tableHeaders.allActive = false
    state.pagination.currentPage = 1
  },

  // delete checked items
  DELETE_EMPLOYMENT_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили вид(ы) занятости'
    state.responseModal.type = 'main'
  },
  DELETE_EMPLOYMENT_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems
    errorItems.forEach(e => {
      listNamesErrorItems = listNamesErrorItems + ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении видов занятости произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },
  CLOSE_DELETE_EMPLOYMENT_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  }
}

const actions = {
  getEmployments ({ state, commit }) {
    const params = {
      sort: '-id',
      take: state.pagination.currentTake,
      page: state.pagination.currentPage
    }
    axios.get(`${url}/employments`, { params, ...config }).then(response => {
      commit('GET_EMPLOYMENTS', response.data.data)
      commit('SET_EMPLOYMENT_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения списка видов занятости', error.response ? error.response : error)
    })
  },

  // переключение всплывающих меню (ред./удалить)
  toggleEmploymentListItemControls ({ commit }, itemId) {
    commit('EMPLOYMENT_LIST_TOGGLE_CONTROLS', itemId)
  },
  // показ модалки редактирования записи
  showEmploymentListUpdateModal ({ commit }, employmentId) {
    commit('SHOW_EMPLOYMENT_LIST_UPDATE_MODAL', employmentId)
  },
  // редактирование имени записи
  setUpdatedEmploymentName ({ commit }, name) {
    commit('SET_UPDATED_EMPLOYMENT_NAME', name)
  },
  // показ модалки создания записи
  showEmploymentListCreateModal ({ commit }) {
    commit('SHOW_EMPLOYMENT_LIST_CREATE_MODAL')
  },
  // редактирование имени новой записи
  setCreatedEmploymentName ({ commit }, name) {
    commit('SET_CREATED_EMPLOYMENT_NAME', name)
  },
  // закрытие всех модалок
  closeEmploymentListModals ({ commit }) {
    commit('CLOSE_EMPLOYMENT_LIST_MODALS')
    // закрываем все всплывашки (ред./удалить)
    commit('CLOSE_EMPLOYMENT_LIST_CONTROLS')
  },
  // создание записи
  createEmployment ({ commit, state }) {
    if (state.createModal.newEmploymentName) {
      const postData = {
        name: state.createModal.newEmploymentName
      }

      axios.post(`${url}/employments`, postData, config).then(response => {
        this.dispatch('getEmployments')
        this.dispatch('closeEmploymentListModals')
      }).catch(error => {
        console.log('Ошибка создания вида занятости:' + error)
      })
    } else {
      commit('SET_EMPLOYMENT_LIST_MODAL_VALIDATION', { modal: 'create', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // редактирование записи
  updateEmployment ({ commit, state }) {
    if (state.updateModal.employment.name) {
      const employmentData = {
        id: state.updateModal.employment.id,
        name: state.updateModal.employment.name
      }

      axios.put(`${url}/employments/${employmentData.id}`, employmentData, config).then(response => {
        this.dispatch('getEmployments')
        this.dispatch('closeEmploymentListModals')
      }).catch(error => {
        console.log('Ошибка редактирования вида занятости:' + error)
      })
    } else {
      commit('SET_EMPLOYMENT_LIST_MODAL_VALIDATION', { modal: 'update', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // очищаем поля валидации
  clearEmploymentListModalValidation ({ commit }) {
    commit('SET_EMPLOYMENT_LIST_MODAL_VALIDATION', { modal: null, validation: null })
  },
  // удаление записи
  deleteEmployment ({ dispatch }, employmentId) {
    axios.delete(`${url}/employments/${employmentId}`, config).then(response => {
      console.log('Вид занятости успешно удален')
      dispatch('getEmployments')
    }).catch(error => {
      console.log('Ошибка удаления вида занятости:' + error)
    })
  },
  toggleEmploymentListItemActive ({ commit }, itemId) {
    commit('TOGGLE_EMPLOYMENT_LIST_ITEM_ACTIVE', itemId)
  },
  toggleEmploymentListItemActiveAll ({ commit }) {
    commit('TOGGLE_EMPLOYMENT_LIST_ITEM_ACTIVE_ALL')
  },

  // pagination
  getEmploymentListPage ({ commit, dispatch }, pageNum) {
    commit('SET_CURRENT_PAGE', pageNum)
    dispatch('getEmployments')
  },
  resetEmploymentListCurrentPage ({ commit }) {
    commit('RESET_EMPLOYMENT_LIST_CURRENT_PAGE')
  },

  // delete checked items
  deleteEmploymentListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    state.employments.forEach((e) => {
      if (e.isActive) {
        checkedItems.push(e)
      }
    })

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/employments/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления видов занятости', error)
        })
      }
    }
    processMessages(checkedItems).then(() => {
      if (errorItems.length > 0) {
        commit('RESET_EMPLOYMENT_LIST_ALL_CHECKS')
        commit('DELETE_EMPLOYMENT_LIST_CHECKED_ITEMS_ERROR', errorItems)
        dispatch('getEmployments')
      } else {
        commit('RESET_EMPLOYMENT_LIST_ALL_CHECKS')
        commit('DELETE_EMPLOYMENT_LIST_CHECKED_ITEMS_SUCCESS')
        dispatch('getEmployments')
      }
    })
  },
  closeEmploymentListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_EMPLOYMENT_LIST_MODAL')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
